import apis from "@/apis";
import { update } from "../../utils";

const api = apis.accounts.history;

export default {
  namespaced: true,
  state: {
    searchData: {
      targetName: '',
      // 帳號過濾
      users: [],
      // 玩法選像篩選
      filter_play: "",
      // 狀態篩選
      status_filter: "",
      // 三方篩選
      third_party: [],
      market_type: [],
      showPeople: false,
    },
    // 統計表欄位
    normalColumns: [],
    // 明細層欄位
    detailColumns: [],
    // 統計加總欄位
    normalAmountColumns: [],
    // 明細層加總欄位
    detailAmountColumns: [],
    // 投注內容篩選
    betSelectionfilters: [],
    // 日期篩選
    dateRange: {
      startDate: '',
      endDate: '',
    },
    // 三方平台選擇器綁定資料
    thirdPartyData: [],
    clickedUser: null,
    composed: [],
    groupLine: '',
  },
  actions: {
    fetchColumns(context) {
      return api.getColumns().then(response => {
        context.commit('update', {
          normalColumns: response.data.columns,
          detailColumns: response.data.detailColumns,
          detailAmountColumns: JSON.parse(JSON.stringify(response.data.detailAmountColumns)).slice(1),
          normalAmountColumns: response.data.normalAmountColumns,
          betSelectionfilters: response.data.filters,
        });
        
        return Promise.resolve(response);
      });
    }
  },
  mutations: {
    update,
    update_search(state, data) {
      for (let key in state.searchData) {
        if (key in data) {
          state.searchData[key] = data[key];
        }
      }
    }
  }
}